import { FunctionComponent } from 'react'

import { IconProps } from '@fairhq/common/lib/components/atoms/icons/types'

export const Plus: FunctionComponent<IconProps> = ({
  className,
  fill = 'currentColor',
  width = '24',
  height = '25',
}) => (
  <svg
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={width}
    height={height}
  >
    <path
      d="M13.3 11.5613H17.2C17.918 11.5613 18.5 12.1434 18.5 12.8613C18.5 13.5793 17.918 14.1613 17.2 14.1613H13.3V18.0613C13.3 18.7793 12.718 19.3613 12 19.3613C11.282 19.3613 10.7 18.7793 10.7 18.0613V14.1613H6.8C6.08203 14.1613 5.5 13.5793 5.5 12.8613C5.5 12.1434 6.08203 11.5613 6.8 11.5613H10.7V7.66133C10.7 6.94336 11.282 6.36133 12 6.36133C12.718 6.36133 13.3 6.94336 13.3 7.66133V11.5613Z"
      fill={fill}
    />
  </svg>
)
